import Vue from 'vue';
import { ERROR } from '@route-types';

/**
 * Brand and Design
 */
import { defineCustomElements } from '@telekom/scale-components/loader';

/**
 * Plugins
 */

import '@/plugins/axios';
import { i18n } from '@/plugins/vue-i18n';
import { router } from '@/plugins/vue-router';
import Webtrekk from '@/plugins/webtrekk';
import '@/plugins/vue-meta';
import '@/plugins/emitter';

/**
 * Main app
 */
import App from './App';
import store from '@state/store';

Vue.use(Webtrekk, {
  i18n,
  store,
});

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.config.errorHandler = (error, vm, info) => {
  if (error.handled) {
    // already handled in axios.js
    return;
  }
  router.push({ name: ERROR, params: { error, vm, info } });
};

/*
// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException;
}
 */

/**
 * Load system config and i18n messages
 */
// store.dispatch('system/init', { i18n, router });

store.dispatch('system/initResume');

const app = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// If running inside Cypress...
if (window.Cypress || true) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app;
}

/*
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line
  const VueAxe = require('vue-axe');
  Vue.use(VueAxe, {
    config: {
      // ...
      rules: [
        { id: 'heading-order', enabled: true },
        { id: 'label-title-only', enabled: true },
        // and more
      ],
    },
  });
}
*/

// Register custom elements
defineCustomElements().then();
Vue.config.ignoredElements = [/scale-\w*/];
